export default {
  en: {
    backTitle: "Back",
    title: 'Privacy Policy',
    contents: {
      title: 'User Privacy Statement for BestCon',
      text: "BestCon is committed to maintaining your confidence and trust with respect to the privacy of the personal information we collect from you. Please read this privacy policy carefully to understand our practices about how we collect, use, and share your personal information.",
      step: [{
        title: "1.About our Privacy Policy",
        tip: "This privacy policy describes how the personal information that is collected when you visit the BestCon website, application or product that posts a link to this privacy policy ('Service') will be used by Nanjing BestCon Technologies Co., Ltd. that owns the Service (' BestCon,' 'we,' 'us' or 'our'). This policy may be supplemented by additional privacy terms or notices set forth on certain areas of the Service.",
      }, {
        title: "2.Information We Collect",
        tip: "The Service collects information from you in two ways: directly from your input and automatically through the Service's technologies.",
      }, {
        title: "3.Information You Provide",
        tip: "The types of personal information that the Service collects directly from you may include:",
        collections: [{
          text: "     •Contact details, such as your name, email address, postal address, and telephone number."
        }, {
          text: "     •Educational and professional background information."
        }, {
          text: "     •Usernames and passwords."
        },{
          text: "     •Payment information, such as a credit or debit card number."
        }, {
          text: "     •Comments, feedback, posts, and other content you submit to the Service."
        }, {
          text: "     •Interests and communication preferences."
        }, {
          title: "To access certain content and to make use of additional functionality and features of the Service, we ask you to register for an account by completing and submitting a registration form, which may request additional information.",
        }, {
          title: "If you choose to register and sign in by using a third party account (such as your Facebook account), the authentication of your login is handled by the third party and the Service will collect your name, email address and any other information about your third-party account that you agree to share with us at the time you give permission for your account on the Service to be linked to your third party account.",
        }]
      }, {
        title: "4.Information Collected Automatically",
        tip: "The Service also automatically collects, through our servers and the use of cookies (small text files sent to your computer), web beacons (also known as clear or single pixel. gifs) and other technologies, information that tells us how you use the Service, such as:",
        collections: [{
          text: "     •Internet Protocol ('IP') address used to connect your computer to the Internet."
        }, {
          text: "     •Computer, device, and connection information, such as browser type and version, operating system, mobile platform, and unique device identifier ('UDID') and other technical identifiers."
        }, {
          text: "     •Uniform Resource Locator ('URL') click stream data, including date and time stamp, referring and exit URLs, search terms you used, and pages you visited or searched for on the Service."
        },{
          text: "     •For location-aware services, the physical location of your device to provide you with more relevant content for where you are in the world."
        }, {
          title: "We may use and disclose information that does not reveal your identity or permit direct association with any specific individual, such as browser and device information, anonymous usage data and aggregated information, for any purpose, except where we are restricted by law. If we combine non-personal information with personal information, the combined information will be treated as personal information for as long as it remains combined."
        }, {
          title: "You can control cookies through your browser's settings and other tools. However, if you block certain cookies, you may not be able to register, login to the Service, access certain parts of the Service or make full use of the Service."
        }]
      }, {
        title: "5.Use of Your Information",
        tip: "We may use your personal information to:",
        collections: [{
          text: "     •Provide the Service to you, such as allow access to or delivery of our products or services, process or fulfill an order or transaction, or administer surveys or promotional programs."
        }, {
          text: "     •Respond to your requests, inquiries, comments, or concerns."
        }, {
          text: "     •Provide technical, product and other support and help keep the Service working, safe and secure."
        }, {
          text: "     •Offer you customized content and individualized personalization of the Service to make it more relevant to your interests and needs."
        }, {
          text: "     •Enhance, evaluate, and improve the Service, its advertisements and promotional campaigns and our products and services and to develop new products and services."
        }, {
          text: "     •Identify and analyze usage trends, including for the purposes of research, audits, reporting and paying royalties and license fees to third-party content providers."
        }, {
          text: "     •Notify you about changes or updates to the Service and our products and services."
        }, {
          text: "     •Provide you special offers, promotions, surveys, and other information about the Service as well as products, events and services of ours, our affiliates and non-affiliated third parties such as societies and sponsors."
        }, {
          title: "We may on occasion also match or combine the personal information that you provide with information that we obtain from other sources or that is already in our records, whether collected online or offline or by predecessor or affiliated group companies, for the purposes described above."
        }]
      }, {
        title: "6.Disclosure of Your Information",
        tip: "We may share your personal information with:",
        collections: [{
          text: "     •Relevant agents, representatives, joint venturers, and entities for which we are acting as an agent, licensee, or publisher, such as societies and sponsors."
        }, {
          text: "     •Applicable suppliers and service providers, including editors, reviewers, credit card processors, customer support, email service providers, mailing houses and shipping agents, and IT service providers."
        }, {
          title: "to assist us with producing and delivering our products and services, developing, and operating our businesses, systems and applications, processing payments, customer support, marketing, promotion, and communications and for other purposes set forth in this privacy policy."
        }, {
          title: "We also may share your personal information with our affiliated group companies worldwide and with societies, sponsors and other non-affiliated third parties that wish to send you information about their products and services that may be of interest to you as determined by your choices in managing your communications preferences following the process described below."
        }, {
          title: "If the Service offers a content database or learning service ('Subscription Service') and you access the Subscription Service through an institution-sponsored subscription, your personal information and certain usage data gathered through the Subscription Service, such as the number of items you downloaded, any non-subscribed items you accessed, and test scores, may be shared with your institution for the purposes of usage analysis, subscription management, course management and testing and remediation. If your institution is a corporation or other business entity, additional usage data, such as the types of records you viewed and the number of searches you ran, also may be shared for the purposes of cost attribution and departmental budgeting."
        }, {
          title: "We also may need to disclose your personal information:"
        }, {
          text: "     •to respond to or comply with any law, regulation, subpoena, court order or other legal obligation."
        }, {
          text: "     •to enforce and protect our rights and properties."
        }, {
          text: "     •to detect, investigate and help prevent security threats, fraud, or other malicious activity."
        }, {
          text: "     •to protect the rights, property or safety of our users, employees, or others."
        }, {
          text: "     •if BestCon, the Service or a related asset or line of business is acquired by, transferred to, or merged with another company."
        }, {
          title: "The Service may let you post and share personal information, comments, materials, and other content. Any information you disclose publicly may be collected and used by others, may be indexable by search engines, and might not be able to be removed. Please be careful when disclosing personal information in these public areas."
        }]
      }, {
        title: "7.Your Choices and Communications Preferences",
        tip: "You can manage your communications preferences when you register with the Service, by updating your account preferences, by using the 'opt-out' or unsubscribe mechanism or other means provided within the communications that you receive from us or by contacting us. We reserve the right to notify you of changes or updates to the Service whenever necessary.",
      }, {
        title: "8.Access to and Accuracy of Your Information",
        tip: "The Service may allow registered users to access their account information and make corrections or updates upon log in at any time. The accuracy of such information is solely the responsibility of the user. You may also request access to other personal information about you that may be held in the Service. If you request to deactivate your account or delete your personal information, we will endeavor to fulfill your request, but some personal information may persist in backup copies for a certain period and may be retained as necessary for legitimate business purposes or to comply with our legal obligations.",
      }, {
        title: "9.Data Security",
        tip: "BestCon takes precautions to safeguard your personal information against loss, theft and misuse and unauthorized access, disclosure, alteration, and destruction using appropriate administrative, physical and technical security measures.",
      }, {
        title: "10.Cross-Border Transfer of Your Information",
        tip: "Your personal information may be transferred to other countries for processing. By using the Service, you consent to the transfer of information to countries outside of your country of residence, which may have different personal data protection rules than in your country.",
      }, {
        title: "11.Changes to Our Privacy Policy",
        tip: "We may change this privacy policy from time to time. Any changes will be posted on this page with an updated revision date.",
      }, {
        title: "12.Contact",
        tip: "If you have any questions, comments or requests regarding this privacy policy or our processing of your information, please contact: Nanjing BestCon Technologies Co., Ltd.",
        collections: [{
          text: "Email: info@mybestcon.com"
        }]
      }]
    }
	},
  "zh-cn": {
    backTitle: "返回",
    title: '隐私声明',
    contents: {
      title: '倍联智能隐私政策',
      text: "",
      step: [{
        title: "1.杭州博联智能科技股份有限公司及其附属公司（以下合称为“我们”或“倍联”）致力于保护您的个人隐私。本隐私政策（下称“本政策”）阐述了在您使用下列服务、产品和相关移动应用程序（统称为“产品”）期间，我们如何处理个人数据并保障信息隐私。",
        tip: "",
      },{
        title: "1.1倍联智能手机应用程序和智能生活移动应用程序在本政策中，“个人数据”是指单独使用或者结合其他信息使用能够识别个人身份的信息。“智能设备”是指硬件制造商生产或制造的，具有人机界面并且可以通过无线网络传输数据的非标准计算设备，包括智能家用电器、智能可穿戴设备、智能空气净化设备等。“应用程序”是指由倍联开发的移动应用程序，能够帮助终端用户远程控制智能设备并连接至倍联物联网（IoT）平台。",
        tip: "",
      }, {
        title: "1.2对于由倍联提供支持服务的其他品牌商的移动应用程序，将由我们的客户决定要通过我们的产品收集哪些个人数据。我们根据客户的要求收集信息，此类信息的处理仅限于提供客户与我们约定的服务。如果您是我们客户的用户，并且您不希望使用我们服务的客户联系您，请直接联系该客户并告知您的诉求。 我们收集哪些个人数据",
        tip: "",
      }, {
        title: "1.3为了向您提供我们的服务，我们会要求您提供此类服务所必须的个人数据。如果您不提供个人数据，我们可能无法为您提供我们的产品或服务。",
        tip: "",
      }, {
        title: "2.您自愿向我们提供的信息",
        tip: "帐户或个人资料数据：当您注册我们的帐户时，我们可能会收集您的姓名和联系方式，如您的电子邮件地址、电话号码、用户名和登录凭据。在您与我们的产品交互期间，我们可能会进一步收集您帐户中的昵称、头像、国家代码、语言偏好或时区信息等。 反馈：当您使用我们产品中的反馈和建议功能时，我们会收集您的电子邮件地址、手机号码和反馈内容，以便及时处理您的问题和设备故障。",
      }, {
        title: "3.我们自动收集的信息【必选和经特别授权同意信息】",
        tip: "",
      }, {
        title: "3.0【必选】基本账户信息：手机号码以及邮箱地址；密码。",
        tip: "",
      }, {
        title: "3.1【必选】手机设备相关信息：当您与我们的产品交互时，我们会自动收集设备信息，如定位权限：设备配网时候需要Android6.0以上获取设备WiFI信息（包括附近WiFI列表）的定位权限；手机型号相应信息、IP地址、无线连接信息、操作系统类型和版本、应用程序版本号、推送通知标识符、日志文件和移动网络信息。",
        tip: "",
      }, {
        title: "3.2【必选】智能设备基本信息：当您使用与我们的产品或服务连接的智能设备时，我们可能会收集有关智能设备的基本信息，如设备名称、设备的MAC地址、设备红码数据及学习所需的红码数据、设备ID、在线状态、激活时间、固件版本和升级信息等。",
        tip: "",
      }, {
        title: "3.3【必选】日志信息和基本使用数据：当您使用我们的应用程序时，系统和异常日志可能会被上传。在您与我们的网站和服务交互期间，我们会自动收集与访问、点击、下载、发送/接收消息和其他使用我们的网站和服务相关的使用数据。\n" +
            "3.4至3.8款，为经特别授权同意信息，分别为：3.4【经特别授权同意信息】其他账户信息、3.5【经特别授权同意信息】智能设备位置信息、3.6【经特别授权同意信息】家庭信息、3.7【经特别授权同意信息】用户使用功能时正常产生的数据、3.8【经特别授权同意信息】智能设备报告信息。",
        tip: "",
      }, {
        title: "3.4.1【经特别授权同意信息】其他账户信息：您的用户昵称、头像、Facebook（限于IHC APP及IHC for EU APP）授权登录账户名；第三方接入的SDK账户信息等。",
        tip: "",
        collections: [{
          title: "（1）第三方账号登录的SDK接入说明："
        }, {
          title: "微信"
        }, {
          text: "功能：用于帮助用户实现微信登录倍联App"
        }, {
          text: "收集个人信息类型：设备常规信息、mac地址、ip地址"
        }, {
          title: "Google"
        }, {
          text: "功能：用于帮助用户实现Google登录倍联App"
        }, {
          text: "收集个人信息类型：设备常规信息、mac地址、ip地址"
        }, {
          title: "（2）第三方SDK接入说明："
        }, {
          title: "A.用于推送通知功能"
        }, {
          title: "小米"
        }, {
          text: "功能：用于倍联App向小米手机用户推送消息"
        }, {
          text: "收集个人信息类型：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "华为"
        }, {
          text: "功能：用于倍联App向华为手机用户推送消息"
        }, {
          text: "收集个人信息类型：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "OPPO"
        }, {
          text: "功能：用于倍联App向OPPO手机用户推送消息"
        }, {
          text: "收集个人信息类型：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "VIVO"
        }, {
          text: "功能：用于倍联App向VIVO手机用户推送消息"
        }, {
          text: "收集个人信息类型：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "魅族"
        }, {
          text: "功能：用于倍联App向魅族手机用户推送消息"
        }, {
          text: "收集个人信息类型：用户id、IMEI、设备型号等常规信息"
        }, {
          title: "用于App崩溃日志上报"
        }, {
          title: "B.Google firebase crashlytics"
        }, {
          text: "功能：用于倍联App崩溃日志上报"
        }, {
          text: "收集个人信息类型：用户id、奔溃日志、设备型号等常规信息"
        }]
      }, {
        title: "3.4.2【经特别授权同意信息】基于相机/摄像头的附加服务： 您可在开启相机/摄像头权限后使用该功能进行扫码用于添加您购买的设备，加入家庭等功能。请您知晓，即使您已同意开启相机/摄像头权限，我们也仅会在您主动扫码、拍摄等使用相机/摄像头时获取信息。",
        tip: "",
      }, {
        title: "3.4.3【经特别授权同意信息】基于相册（图片库/视频库）的图片/视频访问及上传的附加服务： 您可在开启相册权限后使用该功能上传您的照片/图片/视频，以实现更换头像、上报设备使用问题提供证明等功能。当您使用于头像等功能时，我们不会对此信息进行识别；但是当您上报设备使用问题时我们会通过您所上传的照片/图片来定位您的问题。",
        tip: "",
      }, {
        title: "3.5【经特别授权同意信息】智能设备位置信息：当您使用我们的特定产品或服务（例如扫地机器人和天气服务）时，我们可能会收集有关您的实时精确或非精确地理定位信息。",
        tip: "",
      }, {
        title: "3.6【经特别授权同意信息】家庭信息：家庭名称、家庭所在地区（由您手动设置）、房间信息、家庭背景图片、当地电价。",
        tip: "",
      }, {
        title: "3.7【经特别授权同意信息】用户使用功能时正常产生的数据：场景信息、联动信息、遥控面板信息。",
        tip: "",
      }, {
        title: "3.8【经特别授权同意信息】智能设备报告的信息：根据您选择与我们的产品或服务连接的不同智能设备，我们可能会收集您的智能设备报告的信息。",
      }, {
        title: "3.9.1我们不收集您的个人种族或民族起源、政治观点、宗教、哲学信仰、工会组织成员的数据、个人基因数据或涉及健康、性生活或性取向的数据。我们不会在未经儿童的监护人许可的情况下收集16周岁以下用户的数据，若您是16周岁以下的儿童，请您必须获得您父母或您监护人的许可后才能使用我们的产品和服务。",
      }, {
        title: "3.9.2 您在使用我们产品和服务时，上述【经特别授权同意信息】项目的信息您必须同意我们获取，以免影响您智能产品和服务的正常使用；其他【经特别授权同意信息】项目的信息您有权拒绝我们获取，但是我们可能无法给您提供相应的服务。",
      }, {
        title: "4.处理个人数据的目的和法律依据",
      }, {
        title: "4.1我们处理您信息的目的如下：",
        collections: [{
          title: "（1）为您提供服务：我们处理您的帐户和个人资料数据、设备信息、使用数据、位置信息和智能设备相关信息，以提供您请求或购买的产品和服务。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。"
        }, {
          title: "（2）改善我们的服务：我们处理您的设备信息、使用数据、位置信息和智能设备相关信息，以确保我们产品的功能和安全性，开发和改进我们的产品和服务，分析我们的运营效率，并防止和跟踪欺诈或不当使用行为。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。"
        }, {
          title: "（3）非营销通信：我们处理您的个人数据，旨在向您发送与服务、条款/条件和政策变更和/或其他管理信息相关的重要信息。由于此类信息较为重要，您可能无法选择不接收此类邮件。此类处理的法律依据是根据我们的使用条款履行我们与您的合同。"
        }, {
          title: "（4）营销通信：我们可能会处理您的个人数据，以向您提供与我们产品和服务相关的营销和促销资料。在上述情况中，我们向您发送的每封邮件均含有允许您选择不再接收此类邮件的指示信息。此类处理的法律依据是基于您的同意。"
        }, {
          title: "（5）个性化服务：我们可能会处理您的帐户和个人资料数据、使用数据、设备信息，以设计个性化的产品并为您提供量身定制的服务（例如推荐和显示适合您的产品信息和广告），以及邀请您参与您使用的产品的用户调查。此类处理的法律依据是基于您的同意。"
        }]
      }, {
        title: "4.2合规：我们会在我们认为必要或适当的情况下处理您的个人数据：（a）遵守适用的法律法规；（b）遵守法律程序；（c）响应公共机构和政府当局的要求；（d）履行我们的条款和条件；（e）保护我们的运营、业务和系统；（f）保护我们和/或包括您在内的其他用户的权利、隐私、安全或财产；以及（g）寻求可用的补救措施或限制我们可能需要提供的损害赔偿。",
      }, {
        title: "5.我们与谁共享您的个人数据？",
      }, {
        title: "5.1倍联仅以您知晓的方式共享您的个人数据。我们可能会与下列参与者共享您的个人数据： 向为我们提供某些业务相关服务的第三方（如谷歌、亚马逊、Facebook等）服务提供商披露您的个人数据，例如网站托管、数据分析、支付和信用卡处理、基础设施供应、IT服务、客户支持服务、电子邮件发送服务以及其他类似服务，从而确保他们能够为我们提供服务。",
      }, {
        title: "5.2向直接或间接为您提供智能设备和/或您用来访问和使用我们网站和服务的网络和系统的客户以及其他业务合作伙伴披露您的个人数据。",
      }, {
        title: "5.3当发生重组、合并、出售、合资、让渡、转让或其他处置我们所有或部分业务、资产或股票（包括但不限于与任何破产或类似程序相关的上述情况）的情况时，向附属公司或其他第三方（如谷歌、亚马逊等）披露您的个人数据。在这种情况下，您将通过电子邮件和/或我们的网站收到关于所有权变更、个人数据新的使用方式不兼容以及有关个人数据选择的明确通知。",
      }, {
        title: "5.4在我们认为必要或适当的情况下：（a）遵守适用的法律法规；（b）遵守法律程序；（c）响应公共机构和政府当局的要求，包括您居住的国家/地区以外的公共机构和政府当局；（d）履行我们的条款和条件；（e）保护我们的运营、业务和系统；（f）保护我们和/或包括您在内的其他用户的权利、隐私、安全或财产；以及（g）寻求可用的补救措施或限制我们可能需要提供的损害赔偿。 向公司旗下的子公司或附属公司披露您的个人数据，以定期开展业务活动。 除上述第三方（如谷歌、亚马逊等）以外，我们仅在您同意的情况下向其他第三方（如谷歌、亚马逊等）披露您的个人数据。",
      }, {
        title: "6.所收集信息的国际转移",
      }, {
        title: "6.1为了方便我们的操作，我们可能会在您居住的地方以外的司法管辖区转移、存储和处理您的个人数据。这些国家可能设有不同的数据保护法。在此类情况下，我们会通过以下一种或多种方式确保您的信息得到充分的保护： 根据GDPR第46条批准的“欧盟标准合同条款”达成的协议。有关更多信息，请访问：https://ec.europa.eu/info/law/law-topic/data-protection/data-transfers-outside-eu/model-contracts-transfer-personal-data-third-countries_en. 如果您想进一步了解我们的安全保障措施，您可以通过本政策直接联系我们。",
      }, {
        title: "6.2如果您使用地在欧盟境内，您所有的用户数据优先保留在欧盟境内，但是为了改善您所使用产品的体验，我司会将经您同意上传后的数据传输至欧盟认定的白名单国家和地区（美国、加拿大、瑞士、新西兰）或者中国大陆、日本、俄罗斯的服务器。数据传输出欧盟外的国家和地区，存在一定的数据隐私保护的风险，关于这点，您知晓并且同意数据跨欧盟传输。",
      }, {
        title: "7.与个人数据有关的权利",
      }, {
        title: "7.1我们尊重您的权利，同时也会掌握您的个人数据。您可以行使下列任何一项权利：",
        collections: [{
          title: "（1）通过我们产品中手动进行删除数据操作；"
        }, {
          title: "（2）如您有疑问，请发送邮件至dpo@broadlink.com.cn寻求帮助。"
        }]
      }, {
        title: "7.2您无需支付任何费用，我们将在30天之内作出答复。如果您决定通过电子邮件向我们发送请求，请说明您希望更改哪些信息，您是否希望将您的个人数据从我们的数据库中删除，或者您希望我们在使用您的个人数据时受到哪些限制。请注意，出于安全考虑，我们可能会在进一步处理您的请求之前要求您核实身份。",
      }, {
        title: "7.3您可以：",
        collections: [{
          title: "（1）要求访问我们处理的与您相关的个人数据，您有权知晓被收集的数据情形，包括经您同意上传至云端的数据情形；"
        }, {
          title: "（2）要求我们纠正与您相关的不准确或不完整的个人数据；"
        }, {
          title: "（3）要求删除您的个人数据；及销毁云端备份的数据，销毁操作将默认取消与Alexa/Google平台的互联互通，则云端数据全部同步删除；"
        }, {
          title: "（4）要求我们基于您的同意或与您签订的合同处理您的数据，以及我们自动处理您的数据时，向您本人或第三方（如谷歌、亚马逊等）传输个人数据；"
        }, {
          title: "（5）当我们基于您的同意或我们的正当利益使用您的个人数据时，选择反对或拒绝我们使用您的个人数据；"
        }, {
          title: "（6）您可以注销账号，注销账号后您云端的备份数据将在7个工作日内被同时删除。您拥有随时手动销毁账户以及账户下所有数据的权利，如您有特殊要求的，您可以发送邮件告知我们。"
        }]
      }, {
        title: "8.安全保障措施",
      }, {
        title: "8.1我们采取商业上合理的物理、管理和技术保障措施，以维护您的个人数据的完整性和安全性。倍联提供多种安全保障策略，以有效确保用户和设备的数据安全。在设备访问方面，我们采用倍联专有算法保障数据隔离、访问认证和授权申请。在数据通信方面，支持使用安全算法和传输加密协议以及基于动态密钥的商业级信息加密传输进行通信。在数据处理方面，采用严格的数据过滤和验证以及完整的数据审核流程。在数据存储方面，用户的所有机密信息将进行安全的加密处理以便存储。如果您出于任何原因认为您与我们的交互不再安全（例如，您认为您的倍联帐户的安全性已经受损），请您发送电子邮件至dpo@broadlink.com.cn立即告知我们。",
      }, {
        title: "8.2我们会不定期提升数据的安全保障措施，包括且不限于数据加密、物理措施、数据认证等手段。我们会根据情况需要选择通知您。",
      }, {
        title: "8.3我们设置数据保护官（DPO），其联络邮箱为dpo@broadlink.com.cn。",
      }, {
        title: "8.4若发生您的数据泄露的情况，我们会在72小时内向欧盟或您所在国监管机构报告个人数据的泄露情况，第一时间采取相应的补救措施，并将补救措施向您及欧盟监管机构汇报。若我们未能在72小时内报告监管机构，则我们的后续报告会说明迟延报告的理由。",
      }, {
        title: "8.5数据保留期限",
        tip: "我们将在达成本政策所述目的的最短期限内处理您的个人数据，除非根据特定法律要求需要保留较长时间。我们将根据个人数据的数量、性质和敏感性决定适当的保留期限，在保留期限结束后，我们将销毁您的个人数据。如果我们出于技术原因无法销毁数据，我们将采取适当措施防止您的个人数据被进一步使用。"
      }, {
        title: "9.争议解决",
        tip: "如果您有未解决的隐私或数据使用问题且我们未能提供令您满意的解决方案，请联系中国杭州仲裁委员会进行仲裁，网址：http://www.hzhac.org"
      }, {
        title: "10.关于政策变更的声明",
        tip: "我们可能会根据信息实践的变化对本政策进行更新。如果我们作出任何重大变更，我们将通过电子邮件（发送至您帐户中指定的电子邮件地址）通知您，或于变更生效前在移动应用程序上发布通知。我们建议您定期浏览本页面，以获取有关隐私做法的最新信息。"
      }, {
        title: "11.联系",
      }, {
        title: "11.1【联系我们】如果您对我们的做法或本协议存在任何疑问，请通过以下方式联系我们： 杭州博联智能科技股份有限公司 通讯地址：浙江省杭州市滨江区江二路57号杭州人工智能产业园C幢 电子邮箱：dpo@broadlink.com.cn 对于欧盟数据主体，您有权向监管机构投诉倍联的数据处理活动。",
      }, {
        title: "11.2【隐私协议更新】我们更新隐私协议时，会在1个工作日内向您邮箱发送更新的内容； 您如果拒绝我们《隐私协议》的更新，您有权不同意我们《隐私协议》的更新。 并且您有权要求恢复到原来我们给您提供的类型服务，但您需要发送邮件告知我们， 我们接收邮件的邮箱是dpo@broadlink.com.cn。",
      }]
    }
  },
}




//////////////////
// WEBPACK FOOTER
// ./static/js/privacy.js
// module id = 2ZS2
// module chunks = 0